import {fromEvent} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

export const streamScreenDimensions = fromEvent(window, 'resize').pipe(
	map(() => ({
		width: window.innerWidth,
		height: window.innerHeight,
	})),
	startWith({
		width: window.innerWidth,
		height: window.innerHeight,
	})
);
